import { useSelector } from "react-redux";
import { desktopMarginsCutoff } from "../styleConstants";

// This component simply displays the company phone number to contact us for help.
// It makes it like a phone clickable link on mobile view, and regular text for desktop
const VvPhoneNumber = () => {
  const screenWidth = useSelector((state) => state.screenWidth.value);

  // either return linky phone or plain text phone depending on screen width
  let phone = (
    <a
      href="tel:+16506464333"
      style={{ color: "inherit", textDecoration: "none" }}
    >
      (650) 646-4333
    </a>
  );
  if (screenWidth >= desktopMarginsCutoff) {
    phone = <>(650) 646-4333</>;
  }

  return phone;
};

export default VvPhoneNumber;
